/* tslint:disable */
/* eslint-disable */
// @ts-ignore
import * as Types from '../../../../global-graphql-types'

import { DocumentNode } from 'graphql'
import * as Apollo from '@apollo/client'
import * as ApolloReactHooks from 'utils/extendApolloHooks'
const defaultOptions = {} as const
export type MarketsNearMeQueryVariables = Types.Exact<{
  limit: Types.Scalars['Int']
}>

export type MarketsNearMeQuery = {
  __typename: 'Query'
  markets: {
    __typename: 'MarketCollection'
    total: number
    records: Array<{
      __typename: 'Market'
      id: number
      name: string
      customerPath: string
      stateFull: string
    }>
  }
  structuredData: {
    __typename: 'StructuredData'
    foodTrucksNearMePage: Array<string> | null
  }
  foodTypePages: Array<{
    __typename: 'FoodTypePage'
    id: number
    name: string
    customerPath: string
    image: { __typename: 'ImageAttachment'; url: string } | null
  }>
  nearbyMarkets: {
    __typename: 'MarketCollection'
    records: Array<{
      __typename: 'Market'
      id: number
      name: string
      imageAuthor: string | null
      imageAuthorUrl: string | null
      imageLicense: string | null
      customerTrucksMapPath: string
      customerPath: string
      distance: number | null
      latitude: number
      longitude: number
      topTrucksEnabled: boolean
      image: { __typename: 'MarketImage'; original: string | null }
      popularTrucks: {
        __typename: 'TruckCollection'
        records: Array<{
          __typename: 'Truck'
          id: number
          name: string
          scheduleUrl: string
        }>
      }
      marketTopTrucks: Array<{
        __typename: 'MarketTopTruck'
        id: number
        truck: {
          __typename: 'Truck'
          id: number
          name: string
          scheduleUrl: string
        }
      }>
      lots: {
        __typename: 'LotCollection'
        records: Array<{
          __typename: 'Lot'
          id: number
          name: string
          longitude: number
          latitude: number
          lotPath: string
        }>
      }
    }>
  }
}

export const MarketsNearMeQueryDocument = ({
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'MarketsNearMeQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'limit' }
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'markets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'records' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'customerPath' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'stateFull' }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'structuredData' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'foodTrucksNearMePage' }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'foodTypePages' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'active' },
                value: { kind: 'BooleanValue', value: true }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'featured' },
                value: { kind: 'BooleanValue', value: true }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'customerPath' }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'image' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'url' },
                        name: { kind: 'Name', value: 'variantUrl' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'height' },
                            value: { kind: 'IntValue', value: '600' }
                          },
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'width' },
                            value: { kind: 'IntValue', value: '600' }
                          },
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'format' },
                            value: { kind: 'EnumValue', value: 'jpg' }
                          }
                        ]
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'nearbyMarkets' },
            name: { kind: 'Name', value: 'markets' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'nearMe' },
                      value: { kind: 'BooleanValue', value: true }
                    }
                  ]
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'page' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'limit' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'limit' }
                      }
                    }
                  ]
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'records' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'image' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'original' }
                            }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'imageAuthor' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'imageAuthorUrl' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'imageLicense' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'customerTrucksMapPath' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'customerPath' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'distance' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'latitude' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'longitude' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'popularTrucks' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'page' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'limit' },
                                  value: { kind: 'IntValue', value: '3' }
                                }
                              ]
                            }
                          }
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'records' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'name' }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'scheduleUrl' }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'topTrucksEnabled' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'marketTopTrucks' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'truck' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'name' }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'scheduleUrl' }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lots' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'filter' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'active' },
                                  value: { kind: 'BooleanValue', value: true }
                                },
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'or' },
                                  value: {
                                    kind: 'ListValue',
                                    values: [
                                      {
                                        kind: 'ObjectValue',
                                        fields: [
                                          {
                                            kind: 'ObjectField',
                                            name: {
                                              kind: 'Name',
                                              value: 'custom'
                                            },
                                            value: {
                                              kind: 'BooleanValue',
                                              value: false
                                            }
                                          }
                                        ]
                                      },
                                      {
                                        kind: 'ObjectValue',
                                        fields: [
                                          {
                                            kind: 'ObjectField',
                                            name: {
                                              kind: 'Name',
                                              value: 'locationsThisWeekGte'
                                            },
                                            value: {
                                              kind: 'IntValue',
                                              value: '1'
                                            }
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                }
                              ]
                            }
                          },
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'page' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'limit' },
                                  value: { kind: 'IntValue', value: '3' }
                                }
                              ]
                            }
                          },
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'sort' },
                            value: {
                              kind: 'ListValue',
                              values: [
                                {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'field' },
                                      value: {
                                        kind: 'EnumValue',
                                        value: 'locations_this_week_count'
                                      }
                                    },
                                    {
                                      kind: 'ObjectField',
                                      name: {
                                        kind: 'Name',
                                        value: 'direction'
                                      },
                                      value: {
                                        kind: 'EnumValue',
                                        value: 'desc'
                                      }
                                    }
                                  ]
                                },
                                {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'field' },
                                      value: {
                                        kind: 'EnumValue',
                                        value: 'name'
                                      }
                                    },
                                    {
                                      kind: 'ObjectField',
                                      name: {
                                        kind: 'Name',
                                        value: 'direction'
                                      },
                                      value: { kind: 'EnumValue', value: 'asc' }
                                    }
                                  ]
                                }
                              ]
                            }
                          }
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'records' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'name' }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'longitude' }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'latitude' }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'lotPath' }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown) as DocumentNode

/**
 * __useMarketsNearMeQuery__
 *
 * To run a query within a React component, call `useMarketsNearMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketsNearMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketsNearMeQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useMarketsNearMeQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    MarketsNearMeQuery,
    MarketsNearMeQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    MarketsNearMeQuery,
    MarketsNearMeQueryVariables
  >(MarketsNearMeQueryDocument, options)
}
export function useMarketsNearMeQueryLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    MarketsNearMeQuery,
    MarketsNearMeQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    MarketsNearMeQuery,
    MarketsNearMeQueryVariables
  >(MarketsNearMeQueryDocument, options)
}
export type MarketsNearMeQueryHookResult = ReturnType<
  typeof useMarketsNearMeQuery
>
export type MarketsNearMeQueryLazyQueryHookResult = ReturnType<
  typeof useMarketsNearMeQueryLazyQuery
>
export type MarketsNearMeQueryQueryResult = Apollo.QueryResult<
  MarketsNearMeQuery,
  MarketsNearMeQueryVariables
>
